/* JS helpers for email lead form */
import {validateEmailAddress} from '@utils/form_validations';

import {IS_PROD} from '@variables';

const signUpForm = document.getElementById('js-email-lead');
if (signUpForm) {
  const _ITERABLE_MARKETING_LIST_ID = IS_PROD
    ? 'dd3f792d-0e1b-4cc4-a05a-2f2acaca4ac3'
    : '000934be-868d-40f6-ab75-3234959c72bb';
  const signUpInput = signUpForm.email;
  const signUpSubmitButton = signUpForm.submit;
  const messageDiv = document.getElementById('js-email-lead-message');
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formProps = Object.fromEntries(formData);
    // Only capture email if provided email is valid
    if (validateEmailAddress(formProps.email).isValid) {
      signUpInput.classList.add('loading');
      signUpSubmitButton.disabled = true;
      signUpInput.disabled = true;
      messageDiv.classList.add('hidden');
      fetch(
        `//links.iterable.com/lists/publicAddSubscriberForm?publicIdString=${_ITERABLE_MARKETING_LIST_ID}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: formProps.email,
          }),
        }
      )
        .then((res) => {
          if (res.status === 200) {
            signUpSubmitButton.disabled = false;
            signUpInput.disabled = false;
            signUpInput.classList.remove('loading');
            signUpInput.value = '';
            signUpInput.placeholder = 'You’ll hear from us soon!';
          } else {
            handleError();
          }
        })
        .catch(() => {
          handleError();
        });
    }
  };

  const validateEmail = (e) => {
    messageDiv.classList.add('hidden');
    signUpInput.placeholder = 'Enter email address';
    if (!e.target.value) {
      signUpInput.classList.remove('valid');
      signUpInput.classList.remove('invalid');
    } else if (validateEmailAddress(e.target.value).isValid) {
      signUpInput.classList.remove('invalid');
      signUpInput.classList.add('valid');
    } else {
      signUpInput.classList.remove('valid');
      signUpInput.classList.add('invalid');
    }
  };

  const handleError = () => {
    signUpInput.disabled = false;
    signUpInput.classList.remove('valid');
    signUpInput.classList.remove('loading');
    signUpSubmitButton.disabled = false;
    messageDiv.classList.remove('hidden');
    messageDiv.innerText = 'Something went wrong, please try again.';
  };

  signUpForm.addEventListener('submit', handleSubmit);
  signUpInput.addEventListener('input', validateEmail);
}
